/* eslint-disable max-len */
import React from 'react';
import classNames from 'classnames';
import { FiChevronDown } from 'react-icons/fi';
import useFooterQuery from './useFooterQuery';
import CookiePreferencesButton from '../../components/CookiePreferencesButton';

import {
	Accordion,
	AccordionItem,
	AccordionControl,
	AccordionPanel
} from '../../components/Accordion';
import Link from '../../components/Link';
import SocialIcons from '../../components/SocialIcons';

import renderIcon from '../../utils/renderIcon';

const ns = `site-footer`;

const renderCopyRight = () => {
	return `©${ new Date().getFullYear() } Balanced Body`;
};

const Footer = () => {
	const {
		wp: {
			acfOptionsFooter: {
				acfFooterSettings: {
					footer: {
						primaryNavigationItems,
						secondaryNavigationItems,
						socialMedia = [],
					},
				},
			},
		},
	} = useFooterQuery();

	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	function openKlaviyoModal(e) {
		e.preventDefault();
		window._klOnsite = window._klOnsite || [];
		window._klOnsite.push(['openForm', 'VDRDZv']);
	}

	return (
		<footer className={rootClassnames}>
			<div className={`container`}>
				<div className={`${ ns }__top`}>
					<div className={`${ ns }__col`}>
						<div className={`${ ns }__social`}>
							<p>Stay Connected.</p>
							<SocialIcons items={socialMedia} />
							<button
								onClick={openKlaviyoModal}
							>
								Sign up for our
								{' '}
								<u>newsletter</u>
								.
							</button>
							<p>
								Can’t find what you’re looking for?
								<br />
								Give us a call at 916-388-2838
								<br />
								In UK? Toll free: 0800 014 8207
							</p>
						</div>
					</div>
					<div className={`${ ns }__col`}>
						<PrimaryNav items={primaryNavigationItems} />
						<div className={`${ ns }__accordion`} aria-hidden>
							<PrimaryNavAccordion items={primaryNavigationItems} />
						</div>
					</div>
				</div>
				<div className={`${ ns }__bottom`}>
					<div className={`${ ns }__icon`}>
						<Link to={`/accessibility`} aria-label={`Visit accessibility page`}>
							{renderIcon('accessibility')}
						</Link>
					</div>
					<SecondaryNav items={secondaryNavigationItems} />
					<div>
						{renderCopyRight()}
					</div>
					{/* <p>Can’t find what you’re looking for? Give us a call at 916-388-2838</p> */}
				</div>
			</div>
		</footer>
	);
};

export default Footer;

// Navigation functions

function PrimaryNav({ items }) {
	if (!items) return null;

	return (
		<nav>
			<ul>
				{items.map(({ heading, items: children }) => {
					return (
						<li key={heading}>
							{heading && (
								<div className={`text-large`}>
									{heading}
								</div>
							)}
							{children?.length > 0 && (
								<ul>
									{children.map(({ link }) => {
										const {
											label,
											url,
										} = link;

										if (!label || !url) return null;

										return (
											<li key={label}>
												<Link
													to={url}
												>
													<span>{label}</span>
												</Link>
											</li>
										);
									})}
								</ul>
							)}
						</li>
					);
				})}
			</ul>
		</nav>
	);
}

function PrimaryNavAccordion({ items }) {
	if (!items) return null;

	return (
		<Accordion>
			{items.map(({ heading, items: children }) => {
				if (!heading || !items.length) return null;

				return (
					<AccordionItem key={heading}>
						<AccordionControl>
							<span aria-hidden>
								<FiChevronDown size={17} />
							</span>
							<span className={`text-large`}>
								{heading}
							</span>
						</AccordionControl>
						<AccordionPanel>
							<ul>
								{children.map(({ link }) => {
									const {
										label,
										url,
									} = link;

									if (!label || !url) return null;

									return (
										<li key={label}>
											<Link to={url}>{label}</Link>
										</li>
									);
								})}
							</ul>
						</AccordionPanel>
					</AccordionItem>
				);
			})}
		</Accordion>
	);
}

function SecondaryNav({ items }) {
	if (!items) return null;

	return (
		<nav>
			<ul>
				{items.map(({ link }) => {
					const {
						label,
						url,
					} = link;

					if (!label || !url) return null;

					return (
						<li key={label}>
							<Link
								to={url}
							>
								{label}
							</Link>
						</li>
					);
				})}
				<li>
					<CookiePreferencesButton className={'footer-link-btn'}>
						Cookie Preferences
					</CookiePreferencesButton>
				</li>
			</ul>
		</nav>
	);
}
